import { observer } from 'mobx-react-lite';
import { useCallback, useEffect } from 'react';

import { useStores } from 'src/components/common/root-store-provider/root-store-provider';
import SelectOption, {
  OptionVariants,
} from 'src/components/main/quiz/select-option/select-option';
import { Policy } from 'src/widgets/policy';

import { fbAnalytics } from '@features/Analytics';
import { tikTokEvent } from '@features/Analytics/services/tik-tok-pixel';

import Couple from '../../../../assets/images/quiz/couple.svg';
import Cupid from '../../../../assets/images/quiz/cupid.svg';
import Man from '../../../../assets/images/quiz/man-raising-hand.svg';
import { Image } from '../../../common/Image';
import styles from './welcome-screen-three-variants-ab-test.module.scss';

const BUTTONS_TEXT = [
  {
    value: 0,
    label: 'Check my ex partner',
    image: Man,
  },
  {
    value: 1,
    label: 'Check my current partner',
    image: Couple,
  },
  {
    value: 2,
    label: 'Explore who fits me',
    image: Cupid,
  },
];

const STARS = Array.from({ length: 10 }, (_, index) => (
  <span key={index} className={styles.star}></span>
));
export const WelcomeScreenThreeVariantsABTest = observer(
  ({ onChange }: { onChange: (value: number) => void }) => {
    // @ts-ignore
    const fbLoaded = window.fbq !== undefined;
    // @ts-ignore
    const tikTokLoaded = window.ttq !== undefined;

    const {
      quizStore: { welcome, setWelcome },
    } = useStores();
    const handleClick = useCallback(
      (value: number) => {
        setWelcome(value);
        onChange(value);
      },
      [onChange, setWelcome],
    );

    useEffect(() => {
      if (fbLoaded) {
        fbAnalytics({
          eventName: 'ViewContent',
          postPath: 'event_start_onboard',
        });
      }
    }, [fbLoaded]);

    useEffect(() => {
      if (tikTokLoaded) {
        tikTokEvent('ViewContent');
      }
    }, [tikTokLoaded]);
    return (
      <div className={styles.container}>
        <header>
          <Image src="logo.webp" width={40} height={40} alt="logo" priority />
          <div>
            <h3>Eclipse</h3>
            <p>Personal moon phases calendar</p>
          </div>
        </header>
        <section className={styles.mainSection}>
          <p className={styles.title}>
            Get a compatibility guidance to make eclipses work for you
          </p>
          <h3 className={styles.subtitle}>
            Find your match and get rid of illusions
          </h3>
          <div className={styles.optionsContainer}>
            {BUTTONS_TEXT.map(({ value: anotherValue, label, image }) => (
              <SelectOption
                key={`welcome_screen_three_variants_ab_test_${anotherValue}`}
                onChange={() => handleClick(anotherValue)}
                optionVariant={
                  welcome == null || anotherValue === welcome
                    ? OptionVariants.OptionSelected
                    : OptionVariants.OptionNotSelected
                }
                optionShapeType="leftImageRightText"
                image={image}
                label={label}
              />
            ))}
          </div>
        </section>
        <footer>
          <Policy className={styles.policy} place="burger_menu" />
        </footer>
        <section>{STARS}</section>
      </div>
    );
  },
);
